import { Module } from 'vuex';
import { AuthState } from './types';
import { RootState } from '../types';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: AuthState = {
    token: localStorage.getItem('user-token') || '',
    status: '',
    isNeedChangePassword: JSON.parse(localStorage.getItem('incp') || 'false'),
    username: localStorage.getItem('username') || '',
};

const namespaced: boolean = false;

export const auth: Module<AuthState,RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations
};
